export enum FormFieldType {
  Input = 'input',
  Textarea = 'textarea',
  Dropdown = 'dropdown',
  FullscreenDropdown = 'fullscreenDropdown',
  AddPhoto = 'addPhoto',
  Autosuggest = 'autosuggest',
}
